"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = exports.StyledStop = exports.StyledSpinner = exports.StyledLoader = exports.loaderSizes = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var accessors_1 = require("../themes/accessors");
exports.loaderSizes = {
    sm: 18,
    md: 24,
    lg: 96,
};
exports.StyledLoader = styled_components_1.default('svg').attrs({
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 24 24',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n"], ["\n  width: ", ";\n"])), function (props) { return !!props.size && exports.loaderSizes[props.size] + 'px'; });
var rotate = styled_components_1.keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"], ["\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"])));
exports.StyledSpinner = styled_components_1.default.circle.attrs({
    cx: 12,
    cy: 12,
    r: 10,
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  stroke-width: ", ";\n  fill: none;\n  animation: ", " 1s linear infinite;\n  transform-origin: 50% 50%;\n"], ["\n  stroke-width: ", ";\n  fill: none;\n  animation: ", " 1s linear infinite;\n  transform-origin: 50% 50%;\n"])), accessors_1.borderWidth('md'), rotate);
exports.StyledStop = styled_components_1.default.stop(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  stop-color: ", ";\n"], ["\n  stop-color: ",
    ";\n"])), function (props) { return props.color === 'transparent'
    ? 'hsla(0, 0%, 0%, 0)'
    : accessors_1.color('main', 'base'); });
var Loader = function (_a) {
    var size = _a.size, otherProps = __rest(_a, ["size"]);
    return react_1.default.createElement(exports.StyledLoader, __assign({ size: size }, otherProps),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("linearGradient", { id: 'svg-linear-gradient' },
                react_1.default.createElement(exports.StyledStop, { color: 'main', offset: '0%' }),
                react_1.default.createElement(exports.StyledStop, { color: 'transparent', offset: '33%' }))),
        react_1.default.createElement(exports.StyledSpinner, { stroke: 'url(#svg-linear-gradient)' }));
};
exports.Loader = Loader;
exports.default = exports.Loader;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
